/**
 * ComparisonSection — "us vs. them" feature checklist table.
 *
 * The source data keeps all features in one i18n array; the first 9 are
 * presented as features only we have (close icon for them), and the rest
 * (index >= 9) are features both sides offer (neutral check for them, gold
 * sparkle for us).
 */

import { useTranslation } from 'react-i18next';
import CheckGlyph from '@mui/icons-material/Check';
import CloseGlyph from '@mui/icons-material/Close';

import {
  Section,
  Container,
  SectionHeader,
  SectionEyebrow,
  SectionTitle,
  ComparisonWrap,
  ComparisonTable,
  ComparisonHeader,
  ComparisonColLabel,
  ComparisonRow,
  ComparisonFeature,
  ComparisonCell,
  CheckIcon,
} from '../../common/LandingPage.styled';
import { VellumProIconFlat } from '../../../../components/brand';

/** Index from which both sides have the feature (neutral check for "them"). */
const BOTH_HAVE_THRESHOLD = 9;

export function ComparisonSection() {
  const { t } = useTranslation();
  const features = t('landing.comparison.features', { returnObjects: true }) as string[];

  return (
    <Section alt>
      <Container>
        <SectionHeader>
          <SectionEyebrow>{t('landing.comparison.eyebrow')}</SectionEyebrow>
          <SectionTitle>{t('landing.comparison.title')}</SectionTitle>
        </SectionHeader>
        <ComparisonWrap>
          <ComparisonTable>
            <ComparisonHeader>
              <div />
              <ComparisonColLabel>{t('landing.comparison.others')}</ComparisonColLabel>
              <ComparisonColLabel us>{t('landing.comparison.us')}</ComparisonColLabel>
            </ComparisonHeader>
            {features.map((feature, i) => {
              const themHas = i >= BOTH_HAVE_THRESHOLD;
              return (
                <ComparisonRow key={feature}>
                  <ComparisonFeature>{feature}</ComparisonFeature>
                  <ComparisonCell>
                    <CheckIcon variant={themHas ? 'neutral' : 'no'}>
                      {themHas ? (
                        <CheckGlyph fontSize="inherit" />
                      ) : (
                        <CloseGlyph fontSize="inherit" />
                      )}
                    </CheckIcon>
                  </ComparisonCell>
                  <ComparisonCell>
                    <CheckIcon variant="yes">
                      <VellumProIconFlat size={12} color="#BAA87B" />
                    </CheckIcon>
                  </ComparisonCell>
                </ComparisonRow>
              );
            })}
          </ComparisonTable>
        </ComparisonWrap>
      </Container>
    </Section>
  );
}

export default ComparisonSection;
